import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import gettext from '@sdk/lang/gettext';
import { SaveClientFlags } from '@sdk/authentication/types';

import AnnualPlanAnnouncementSvg from '@web/assets/svg/images/annual-plan-announcement.svg';
import AnnualPlanAnnouncementWithDiscountSvg from '@web/assets/svg/images/annual-plan-announcement-with-discount.svg';
import FeatureAnnouncementModal from '@web/components/FeatureAnnouncementModal/FeatureAnnouncementModal';
import { useAnnualPlanAnnouncement } from '@web/account/AnnualPlanAnnouncement/annualPlanAnnouncement.hooks';

type Props = {
  currentUser: AuthUserType;
  saveClientFlags: SaveClientFlags;
};

const AnnualPlanAnnouncement = ({ currentUser, saveClientFlags }: Props) => {
  const { shouldBeShown, onButtonClick, dismiss, isVisible, isYearlyPlanDiscounted } =
    useAnnualPlanAnnouncement(currentUser, saveClientFlags);

  if (!currentUser || !shouldBeShown) {
    return null;
  }

  return (
    <FeatureAnnouncementModal
      image={
        isYearlyPlanDiscounted ? (
          <AnnualPlanAnnouncementWithDiscountSvg />
        ) : (
          <AnnualPlanAnnouncementSvg />
        )
      }
      isVisible={isVisible}
      dismiss={dismiss}
      title={gettext('Psst! Annual billing is now available.')}
      description={gettext(
        'Update your subscription from a monthly to an annual plan, and forget about payment delays and locked features!'
      )}
      buttonText={gettext('Update')}
      onButtonClick={onButtonClick}
    />
  );
};

export default AnnualPlanAnnouncement;
